<template>
  <div class="container page wallet-page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('ui.wallet.title')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>

    <div class="main-box">
      <div class="label">{{ $t('ui.wallet.set_info') }}</div>

      <van-cell-group>
        <van-field v-model="walletType" :label="$t('ui.wallet.asset')" readonly />
        <div class="network-options">
          <button
            v-for="item in networkOptions"
            :key="item.key"
            type="button"
            class="network-pill"
            :class="{ active: selectedOptionKey === item.key }"
            @click="selectNetwork(item.key)"
          >
            {{ item.label }}
          </button>
        </div>
        <van-field
          v-model="bankfenhang"
          :label="$t('ui.wallet.network')"
          placeholder="ERC20 / TRC20 / BTC / ETH"
        />
        <van-field
          v-model="bankid"
          :label="$t('ui.wallet.address')"
          type="textarea"
          rows="3"
          autosize
          :placeholder="$t('ui.wallet.address_placeholder')"
        />
        <van-field
          v-model="paypassword"
          :label="$t('ui.wallet.pay_password')"
          type="password"
          :placeholder="$t('ui.wallet.pay_password_placeholder')"
        />
      </van-cell-group>

      <p>{{ $t('ui.wallet.confirm_tip') }}</p>
    </div>

    <div class="sub-btn" @click="bindCard()">
      {{ $t('ui.wallet.save') }}
    </div>
  </div>
</template>

<script>
const WALLET_OPTIONS = [
  { key: 'USDT_ERC20', asset: 'USDT', network: 'ERC20', label: 'USDT-ERC20' },
  { key: 'USDT_TRC20', asset: 'USDT', network: 'TRC20', label: 'USDT-TRC20' },
  { key: 'BTC', asset: 'BTC', network: 'BTC', label: 'BTC' },
  { key: 'ETH', asset: 'ETH', network: 'ETH', label: 'ETH' },
  { key: 'USDC_ERC20', asset: 'USDC', network: 'ERC20', label: 'USDC-ERC20' }
];

export default {
  data() {
    return {
      userInfo: {},
      bankid: '',
      username: '',
      paypassword: '',
      bank: 'USDT',
      bankfenhang: 'ERC20',
      fhnumber: 'ERC20',
      walletType: 'USDT',
      networkOptions: WALLET_OPTIONS,
      selectedOptionKey: 'USDT_ERC20'
    };
  },
  methods: {
    getOptionByKey(key) {
      return WALLET_OPTIONS.find((item) => item.key === key) || WALLET_OPTIONS[0];
    },
    getOptionByBankInfo(asset, network) {
      const safeAsset = String(asset || '').trim().toUpperCase();
      const safeNetwork = String(network || '').trim().toUpperCase();
      return WALLET_OPTIONS.find((item) => item.asset === safeAsset && item.network === safeNetwork) || WALLET_OPTIONS[0];
    },
    back() {
      return window.history.back();
    },
    selectNetwork(optionKey) {
      const option = this.getOptionByKey(optionKey);
      this.selectedOptionKey = option.key;
      this.bankfenhang = option.network;
      this.fhnumber = option.network;
      this.bank = option.asset;
      this.walletType = option.asset;
    },
    bindCard() {
      if (this.userInfo.bankid) {
        this.$toast(this.$t('ui.wallet.toast_already_set'));
        return true;
      }

      if (!this.bankfenhang) {
        this.$toast.fail(this.$t('ui.wallet.toast_need_network'));
        return false;
      }

      if (!this.bankid) {
        this.$toast.fail(this.$t('ui.wallet.toast_need_address'));
        return false;
      }

      if (!this.paypassword) {
        this.$toast.fail(this.$t('ui.wallet.pay_password_placeholder'));
        return false;
      }

      const currentOption = this.getOptionByKey(this.selectedOptionKey);
      this.fhnumber = currentOption.network;
      this.bankfenhang = currentOption.network;
      this.bank = currentOption.asset;
      this.walletType = currentOption.asset;
      this.username = this.userInfo.name || this.userInfo.username || this.$t('ui.wallet.default_username', { asset: this.bank });

      this.$http({
        method: 'post',
        data: {
          bankid: this.bankid,
          bank: this.bank,
          username: this.username,
          bankfenhang: this.bankfenhang,
          fhnumber: this.fhnumber
        },
        url: 'user_set_bank'
      }).then((res) => {
        if (res.code === 200) {
          this.$router.push({ path: '/Mine' });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (!this.userInfo.paypassword) {
            this.$toast(this.$t('ui.wallet.toast_need_pay_pwd'));
            this.$router.push({ path: '/SetPayPassword' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            const info = res.data.info || {};
            const currentOption = this.getOptionByBankInfo(info.bankinfo, info.bankfenhang || info.fhnumber);
            this.selectedOptionKey = currentOption.key;
            this.bank = currentOption.asset;
            this.walletType = currentOption.asset;
            this.bankfenhang = currentOption.network;
            this.fhnumber = currentOption.network;
            this.bankid = info.bankid || '';
            this.username = info.username || '';
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.wallet-page {
  min-height: 100vh;
}

.main-box {
  padding-top: 12px;
}

.label {
  padding: 20px 26px;
  font-size: 35px;
  color: #f3c7a2;
  font-weight: 700;
}

::v-deep .van-cell-group {
  background-color: transparent;
  padding: 12px 0 24px;
}

.network-options {
  display: flex;
  gap: 14px;
  padding: 0 30px 18px;
  flex-wrap: wrap;
}

.network-pill {
  min-width: 132px;
  padding: 14px 24px;
  border: 1px solid #766350;
  border-radius: 999px;
  background: rgba(33, 33, 33, 0.92);
  color: #f3c7a2;
  font-size: 24px;
  font-weight: 700;
}

.network-pill.active {
  border-color: #f0be88;
  background: linear-gradient(180deg, #5b412f, #2f241e);
  box-shadow: 0 0 0 2px rgba(240, 190, 136, 0.18);
}

::v-deep .van-cell-group:after {
  display: none;
}

::v-deep .van-cell {
  box-sizing: border-box;
  width: auto;
  margin: 0 30px 20px;
  padding: 20px 26px;
  border: 1px solid #766350;
  border-radius: 14px;
  background: linear-gradient(120deg, #212121, #313131);
  font-size: 28px;
}

::v-deep .van-cell:after {
  display: none;
}

::v-deep .van-field__label {
  color: #f0be88;
  width: 170px;
}

::v-deep .van-field__control {
  color: #f3c7a2;
}

.main-box p {
  padding: 0 30px;
  font-size: 28px;
  line-height: 1.5;
  color: #f3c7a2;
}

.sub-btn {
  display: block;
  margin: 60px 40px 0;
  padding: 20px 0;
  border: none;
  border-radius: 2rem;
  background: linear-gradient(#fde3ca, #e7b486);
  color: #68302c;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
}
</style>
